import * as React from "react";
import Dropdown from "../../Dropdown/Dropdown";
import Input from "../../Input-new/Input";
import SelectFirm from "../../SelectFirm/SelectFirm";
import SelectTeam from "../../SelectTeam-new/SelectTeam";
import UploadFiles from "./UploadFiles";
import moment from "moment";
import { priceToNumber } from "./Loan";
import { GET_COMPANY_FIRM_BY_ARC_ID } from "../../Graphql/CompanyQueries/allCompanyQuery";
import { fetchData, mutateData } from "../../Service/graphQlService";
import {formatToDateOnly } from "../../../utils";

const items=[{
    label:'Seller Statement',
    name:'seller_statement_file'
    },{
    label:'Buyer Statement',
    name:'buyer_statement_file'
    }];

const SaleInformation = ({isSeniorAgent, isAgent, data, handleChangeInput, handleChangeDropdown, handleInputBlur, handleChangeFile, viewMode, deleted, isReferral, isFinancing, isStriveFinancing, isExtraPayment,calculateGrossAmount}) => {
    const isHsc = data.source === "HSC" || data.hsc_financing;
    const [firmNames,setFirmNames]= React.useState([]);
    const [buyerName,setBuyerName]= React.useState('');
    const [referralListSideFirm,setReferralListSideFirm]= React.useState('');
    const [referralBuyerSideFirm,setReferralBuyerSideFirm]= React.useState('');
    const [listFeeAuto,setListFeeAuto]= React.useState('');
    const [buySideFeeAuto,setBuySideFeeAuto]= React.useState('');
    const [totalClosingFeeAuto,setTotalClosingFeeAuto]= React.useState('');
    const [isLoading,setisLoading] = React.useState(false);
    const todaysDate = moment(new Date()).format('dddd, MMMM D, YYYY');
    const purchasePrice = data.negotiation_price ? `${(priceToNumber(data.negotiation_price)).toLocaleString("en-US")}` :'0';
    const striveFEE = data.potential_fee ? `$${data.potential_fee}` :'$0';
    const formattedBuySideFee = data.buyside_fee ? priceToNumber(data.buyside_fee):0;
    const formattedListSideFee = data.list_fee ? priceToNumber(data.list_fee) : 0;
    const formattedStriveFee = data.potential_fee ? priceToNumber(data.potential_fee) : 0;
    const externalBroker = ((data.listing_agent_firm_name && data.listing_agent_firm_name!=="STRIVE" && data.listing_agent_firm_name) ||(buyerName!=="STRIVE" && buyerName));
    const formattedBuyListFee = ((data.listing_agent_firm_name && data.listing_agent_firm_name!=="STRIVE" && formattedListSideFee) ||(buyerName && buyerName!=="STRIVE" && formattedBuySideFee));
    const formattedTotalFEE = data.negotiation_price ? priceToNumber(data.negotiation_price) : 0;
    
    const buyerAgentFirmId = data.buyer_agent_4_firm ? data.buyer_agent_4_firm : '';
    const referralListsideFirmId = data.referring_listing_agent_firm ? data.referring_listing_agent_firm : '';
    const referralBuysideFirmId = data.referring_buyer_agent_firm ? data.referring_buyer_agent_firm : '';
   
     
    const imageUrl = externalBroker ? 'https://strivenext.s3.us-east-1.amazonaws.com/invoice_new/STRIVE_INVOICE_1.jpg'
    : 'https://strivenext.s3.us-east-1.amazonaws.com/invoice_new/STRIVE_INVOICE_2.jpg'
    
    const referralListBuyerInvoiceImageUrl = 'https://strivenext.s3.us-east-1.amazonaws.com/invoice_new/Invoice_Listing_Buying_page-0001.jpg';
    const referralListInvoiceImageUrl = 'https://strivenext.s3.us-east-1.amazonaws.com/invoice_new/Invoice_Listing.jpg';
    const referralBuyerInvoiceImageUrl = 'https://strivenext.s3.us-east-1.amazonaws.com/invoice_new/Invoice_Buying.jpg';
    

    const onlyBothReferralsInvoiceImageUrl = 'https://strivenext.s3.us-east-1.amazonaws.com/invoice_new/STRIVE-Invoice-Both-Referrals.jpg';
    const onlyOneReferralInvoiceImageUrl = 'https://strivenext.s3.us-east-1.amazonaws.com/invoice_new/STRIVE-Invoice-One-Referral.jpg';
    
    const ifReferralAgentSelected = data.referring_listing_agent_firm || data.referring_buyer_agent_firm;
    
    const referralInvoiceImageUrl = (() => {
        if (data.referring_listing_agent_firm && data.referring_buyer_agent_firm) {
            return externalBroker ? referralListBuyerInvoiceImageUrl : onlyBothReferralsInvoiceImageUrl;
        } else if (data.referring_listing_agent_firm && !data.referring_buyer_agent_firm) {
            return externalBroker ? referralListInvoiceImageUrl : onlyOneReferralInvoiceImageUrl;
        } else if (!data.referring_listing_agent_firm && data.referring_buyer_agent_firm) {
            return externalBroker ? referralBuyerInvoiceImageUrl : onlyOneReferralInvoiceImageUrl;
        }
        return ""; 
    })();
    
    const getClassName = (baseClass) => {
        if (data.referring_listing_agent_firm && data.referring_buyer_agent_firm) {
            return `${baseClass}-both-referral`;
        } else if (data.referring_listing_agent_firm || data.referring_buyer_agent_firm) {
            return `${baseClass}-one-referral`;
        } 
        return baseClass;
    };
    
    let sellerPercentage,buyerCommission =0 ;
    let totalCommission = `$${(externalBroker ? (formattedStriveFee + formattedBuyListFee +priceToNumber(referralListsideCommission) + priceToNumber(referralBuysideCommission)) :(formattedStriveFee)).toLocaleString(undefined,{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    let referralListsideCommission,referralBuysideCommission = 0 ;
    
    function displayBrokerFee(){
        if(data.listing_agent_firm_name && data.listing_agent_firm_name !=="STRIVE" && formattedListSideFee){
            return data.list_fee ? `$${data.list_fee}` : '$0';
        }
        if(buyerName && buyerName!=="STRIVE" && formattedBuySideFee){
            return data.buyside_fee? `$${data.buyside_fee}` : '$0';
        }        
        if(buyerCommission){
            return `$${buyerCommission.toLocaleString(undefined,{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        }        
        return '$0'
    }
    
    function externalBrokerCommission(){
        
        if(formattedTotalFEE && formattedBuyListFee){
            const commissionPercent = (formattedBuyListFee / formattedTotalFEE) * 100;
            return `${externalBroker} - ${commissionPercent.toFixed(2)}% of Purchase Price`;
        }

        if(data.buyer_agent_4_percent){
            // calculate outside agent percentage
            const formattedExternalPercent = parseFloat(data.buyer_agent_4_percent);
            const feePercentage = data.seller_fee_percentage ? parseFloat(data.seller_fee_percentage) : 0;
            sellerPercentage = ((formattedExternalPercent / 100) * (feePercentage / 100)) * 100;
            buyerCommission = (sellerPercentage/100) * (formattedTotalFEE);
            totalCommission = `$${(externalBroker ? (formattedStriveFee + formattedBuyListFee +buyerCommission) :(formattedStriveFee)).toLocaleString(undefined,{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            return `${externalBroker} - ${sellerPercentage.toFixed(2)}% of Purchase Price`;
        }
        if(!data.buyer_agent_4_percent && externalBroker && data.listing_agent_4_percent){
            // calculate outside agent percentage
            const formattedExternalPercent = parseFloat(data.listing_agent_4_percent);
            const feePercentage = data.seller_fee_percentage ? parseFloat(data.seller_fee_percentage) : 0;
            sellerPercentage = ((formattedExternalPercent / 100) * (feePercentage / 100)) * 100;
            buyerCommission = (sellerPercentage/100) * (formattedTotalFEE);
            totalCommission = `$${(externalBroker ? (formattedStriveFee + formattedBuyListFee +buyerCommission) :(formattedStriveFee)).toLocaleString(undefined,{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            return `${externalBroker} - ${sellerPercentage.toFixed(2)}% of Purchase Price`;
        }
        return 0; // Return 0 or another value if there's missing data
    }
    function displayReferralListsideCommission(){
        if(data.referring_listing_agent_percent){
            const purchasePrice = data.negotiation_price ? priceToNumber(data.negotiation_price) : 0;
            const formattedReferralListsidePercent = parseFloat(data.referring_listing_agent_percent);
            const feePercentage = data.seller_fee_percentage ? parseFloat(data.seller_fee_percentage) : 0;
            const totalFee = (feePercentage / 100) * purchasePrice;
            referralListsideCommission = (formattedReferralListsidePercent  / 100) * totalFee ;
            return `$${referralListsideCommission.toLocaleString(undefined,{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        }
        return 0; 
    }
    function displayReferralBuyerSideCommission(){
        if(data.referring_buyer_agent_percent){
            const purchasePrice = data.negotiation_price ? priceToNumber(data.negotiation_price) : 0;
            const formattedReferralBuysidePercent = parseFloat(data.referring_buyer_agent_percent);
            const feePercentage = data.seller_fee_percentage ? parseFloat(data.seller_fee_percentage) : 0;
            const totalFee = (feePercentage / 100) * purchasePrice;
            referralBuysideCommission = (formattedReferralBuysidePercent / 100) * totalFee;
            return `$${referralBuysideCommission.toLocaleString(undefined,{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        }
        return 0; 
    }

    function striveFeeCommission(){
        if (formattedStriveFee && formattedTotalFEE) {
            const commissionPercent = (formattedStriveFee / formattedTotalFEE) * 100;
            return `${commissionPercent.toFixed(2)}% of Purchase Price`;
        }
        return 0; 
    }
    function displayStriveFee(){
        const purchasePrice = data.negotiation_price ? priceToNumber(data.negotiation_price) : 0;
        const feePercentage = data.seller_fee_percentage ? parseFloat(data.seller_fee_percentage) : 0;
        const totalFee = (feePercentage / 100) * purchasePrice;
        const result = calculatePercentages(data);
        const striveFee = totalFee * ( result.totalBuyerPercentage / 100 ) + totalFee * ( result.totalListingPercentage / 100 );

        return `$${striveFee.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
     }
    function calculatePercentages(data) {
        const totalBuyerPercentage = 
            (parseFloat(data.buyer_agent_1_percent) || 0) + 
            (parseFloat(data.buyer_agent_2_percent) || 0) + 
            (parseFloat(data.buyer_agent_3_percent) || 0);
    
        const totalListingPercentage = 
            (parseFloat(data.listing_agent_1_percent) || 0) + 
            (parseFloat(data.listing_agent_2_percent) || 0) + 
            (parseFloat(data.listing_agent_3_percent) || 0);
    
        return {
            totalBuyerPercentage,
            totalListingPercentage
        };
    }
    function referralOutsideAgentPercentageOfPurchasePrice() {
        /* if (!data || !data.buyer_agent_4_percent || !formattedStriveFee || !purchasePrice) {
            return `${externalBroker}`;
        }  */        
        //return `${externalBroker}`;
        var purchasePriceForEnternalBroker = externalBrokerCommission()
        return `${purchasePriceForEnternalBroker}`;
    }

    function referralListsidePercentageOfPurchasePrice() {
        if (!data || !data.referring_listing_agent_percent || !formattedStriveFee || !purchasePrice) {
            return `${referralListSideFirm}`;// - 0% of Purchase Price`;
        }    
        const formattedReferralListSidePercent = parseFloat(data.referring_listing_agent_percent);       
        return `${referralListSideFirm}`;// - ${formattedReferralListSidePercent.toFixed(2)}% of Purchase Price`;
    }
    
    function referralBuysidePercentageOfPurchasePrice() {
        if (!data || !data.referring_buyer_agent_percent || !formattedStriveFee || !purchasePrice) {
            return `${referralBuyerSideFirm}`;// - 0% of Purchase Price`;
        }    
        const formattedReferralBuysidePercent = parseFloat(data.referring_buyer_agent_percent);
        return `${referralBuyerSideFirm}`;// - ${formattedReferralBuysidePercent.toFixed(2)}% of Purchase Price`;
    }

    function calculateCommission(percentage, striveFee) {
        if (!percentage || isNaN(percentage) || !striveFee || isNaN(striveFee)) {
            return 0; 
        }
        const formattedPercentage = parseFloat(percentage).toFixed(2);
        const remainingPercentage = 100 - formattedPercentage;
        return (formattedPercentage / remainingPercentage) * striveFee;
    }
    
    function displayTotalCommission() {
        if (!data) return 0;
        
        if (data.negotiation_price && data.seller_fee_percentage) {
            const purchasePrice = data.negotiation_price ? priceToNumber(data.negotiation_price) : 0;
            const feePercentage = data.seller_fee_percentage ? parseFloat(data.seller_fee_percentage) : 0;
            const totalFee = (feePercentage / 100) * purchasePrice;
            return `$${totalFee.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        }     
        return 0; 
    }
        
    

    function printHscInvoice(event){
        event.preventDefault();
        print();
    }
    function getAggregatedPercentage(data, keys) {
        return keys.reduce((sum, key) => {
            let value = parseFloat(data[key]) || 0; 
            return sum + value;
        }, 0);
    }
    React.useEffect(() => {
       // fetch(0);
        fetchFirm();
        // chnage print page view to portrait
        const style = document.createElement('style');
        style.innerHTML = `
        @media print {
            @page {
                size: portrait;
            }
        }`;
        document.head.appendChild(style);
        const listPrice = data.sold_price ? priceToNumber(data.sold_price) : 0;
        const feePercentage = data.seller_fee_percentage ? parseFloat(data.seller_fee_percentage) : 0;
                
        const purchasePrice = data.negotiation_price ? priceToNumber(data.negotiation_price) : 0;
        const totalFee = (feePercentage / 100) * purchasePrice;
       
        const listingSideKeys = ["listing_agent_1_percent", "listing_agent_2_percent", "listing_agent_3_percent", "listing_agent_4_percent","referring_listing_agent_percent"];
        const buySideKeys = ["buyer_agent_1_percent", "buyer_agent_2_percent", "buyer_agent_3_percent", "buyer_agent_4_percent","referring_buyer_agent_percent"];

        const aggregatedListSide = getAggregatedPercentage(data, listingSideKeys);
        const aggregatedBuySide = getAggregatedPercentage(data, buySideKeys);
        const listsideCommission = (aggregatedListSide  / 100) * totalFee ;
        const buysideCommission = (aggregatedBuySide / 100) * totalFee;

        setListFeeAuto(listsideCommission.toFixed(2));
        setBuySideFeeAuto(buysideCommission.toFixed(2));
        setTotalClosingFeeAuto(((listPrice * feePercentage)/100).toFixed(2));

        return () => {
            document.head.removeChild(style);
        };
    }, [data]);
    
    
    const fetchFirm = async () => {  
        
        try {
            const [listSideResponse, buySideResponse,buyerAgentResponse] = await Promise.all([
               fetchData(GET_COMPANY_FIRM_BY_ARC_ID, { arcId : Number(referralListsideFirmId)}),
               fetchData(GET_COMPANY_FIRM_BY_ARC_ID, { arcId : Number(referralBuysideFirmId)}),
               fetchData(GET_COMPANY_FIRM_BY_ARC_ID, { arcId : Number(buyerAgentFirmId)})
               
            ]);
    
            if (listSideResponse.data && listSideResponse.data.getCompanyByArcId && listSideResponse.data.getCompanyByArcId.company) {
                setReferralListSideFirm(listSideResponse && listSideResponse.data && listSideResponse.data.getCompanyByArcId.company.name || '');
            }
    
            if (buySideResponse.data  && buySideResponse.data.getCompanyByArcId && buySideResponse.data.getCompanyByArcId.company) {
                setReferralBuyerSideFirm(buySideResponse &&buySideResponse.data  && buySideResponse.data.getCompanyByArcId.company.name|| '');
            }
            if(buyerAgentResponse.data && buyerAgentResponse.data.getCompanyByArcId && buyerAgentResponse.data.getCompanyByArcId.company){                
                setBuyerName(buyerAgentResponse && buyerAgentResponse.data && buyerAgentResponse.data.getCompanyByArcId.company.name || '');
            }
           
        } catch (error) {
            console.error("Error fetching firm names:", error);
        } finally {
            setisLoading(true);               
        }
    };

    const maxLength = 49;
    const outsideAgentText = referralOutsideAgentPercentageOfPurchasePrice();
    const splitIndexOutSideAgent = outsideAgentText.length > maxLength ? outsideAgentText.slice(0, maxLength).lastIndexOf(" "):-1;
    const firstLineOutSideAgent = splitIndexOutSideAgent > 0 ? outsideAgentText.slice(0, splitIndexOutSideAgent) : outsideAgentText.slice(0, maxLength);
    const secondLineOutSideAgent = splitIndexOutSideAgent > 0 ? outsideAgentText.slice(splitIndexOutSideAgent + 1) : outsideAgentText.slice(maxLength);


    const referralListSideText = referralListsidePercentageOfPurchasePrice();
    const splitIndexListSide = referralListSideText.length > maxLength ? referralListSideText.slice(0, maxLength).lastIndexOf(" "):-1;
    const firstLineListSide = splitIndexListSide > 0 ? referralListSideText.slice(0, splitIndexListSide) : referralListSideText.slice(0, maxLength);
    const secondLineListSide = splitIndexListSide > 0 ? referralListSideText.slice(splitIndexListSide + 1) : referralListSideText.slice(maxLength);

    const referralBuysideText = referralBuysidePercentageOfPurchasePrice();
    const splitIndexBuySide = referralBuysideText.length > maxLength ? referralBuysideText.slice(0, maxLength).lastIndexOf(" ") : -1;
    const firstLineBuySide = splitIndexBuySide > 0 ? referralBuysideText.slice(0, splitIndexBuySide) : referralBuysideText.slice(0, maxLength);
    const secondLineBuySide = splitIndexBuySide > 0 ? referralBuysideText.slice(splitIndexBuySide + 1) : referralBuysideText.slice(maxLength);
  

    return (
        <React.Fragment>
            {
                !ifReferralAgentSelected ? (
                <React.Fragment>           
                <div className="print-Strive-Invoice" style={{backgroundImage: `url(${imageUrl})`}}>
                    <img src={imageUrl} style={{display: 'none'}}/>
                    <div className="strive-content strive-date">{todaysDate}</div>
                    <div className="strive-content strive-property-info">{data.name} - {data.city}, {data.state}</div>
                    <div className="strive-content purchase-price">{purchasePrice}</div>
                    <div className="strive-content strive-commission">{striveFeeCommission()}</div>
                    <div className="strive-content strive-fee">{striveFEE}</div>                    
                    {
                        externalBroker ? (
                            <React.Fragment>
                            <div className={`strive-content strive-external-broker-firm ${externalBrokerCommission().length >=49 ? 'broker-firm-name':''}`}>{externalBrokerCommission()}</div>
                            <div className="strive-content strive-external-broker-fee">{displayBrokerFee()}</div>
                            <div className="strive-content strive-external-total-fee">{totalCommission}</div>
                            <div className="strive-content strive-external-comments">{data.name} - {data.city}, {data.state}</div>
                            </React.Fragment>
                        ) :(
                            <React.Fragment>
                            <div className="strive-content strive-external-broker-fee">{totalCommission}</div>
                            <div className="strive-content strive-comments">{data.name} - {data.city}, {data.state}</div>
                            </React.Fragment>
                        )
                    }             
                </div> 
                </React.Fragment>) : 
                (
                    <React.Fragment>
                        <div className="print-referral-Invoice" style={{backgroundImage: `url(${referralInvoiceImageUrl})`}}>
                            <img src={referralInvoiceImageUrl} style={{display: 'none'}}/>
                            <div className="strive-content strive-date">{todaysDate}</div>
                            <div className="strive-content strive-property-info">{data.name} - {data.city}, {data.state}</div>
                            <div className="strive-content purchase-price">{purchasePrice}</div>             
                            <div className="strive-content strive-commission">{striveFeeCommission()}</div>
                            <div className="strive-content strive-fee-with-referral">{displayStriveFee()}</div>
                           
                            {data.referring_listing_agent_firm && data.referring_buyer_agent_firm && externalBroker &&(
                                <React.Fragment>                                        
                                    <div className={`strive-content listing-both-referral-with-outside-agent ${
                                        referralListSideText.length >= maxLength ? "listing-both-referral-with-outside-agent-wrap-adjusted" : "" }`}>
                                        <div>{firstLineListSide}</div>
                                        <div>{secondLineListSide}</div>
                                    </div>
                                    <div className={`strive-content listing-commission-both-referral-with-outside-agent`}>
                                        {displayReferralListsideCommission()}
                                    </div>

                                    <div className={`strive-content both-referral-with-outside-agent ${
                                        outsideAgentText.length >= maxLength ? "both-referral-with-outside-agent-wrap-adjusted" : "" }`}>
                                        <div>{firstLineOutSideAgent}</div>
                                        <div>{secondLineOutSideAgent}</div>
                                    </div>
                                    <div className={`strive-content commission-both-referral-with-outside-agent`}>
                                        {displayBrokerFee()}
                                    </div>
                                    
                                    <div className={`strive-content buying-both-referral-with-outside-agent ${
                                        referralBuysideText.length >= maxLength ? "buying-both-referral-wrap-adjusted-with-outside-agent" : ""}`}>
                                        <div>{firstLineBuySide}</div>
                                        <div>{secondLineBuySide}</div>
                                    </div>                                   
                                    <div className={`strive-content buying-commission-both-referral-with-outside-agent`}>
                                        {displayReferralBuyerSideCommission()}
                                    </div>
                                    <div className={`strive-content both-listside-buyside-total-fee-with-outside-agent`}>
                                        {displayTotalCommission()}
                                    </div>
                                    <div className={`strive-content both-listside-buyside-comments-with-outside-agent`}>
                                        {data.name} - {data.city}, {data.state}
                                    </div>
                                </React.Fragment>
                            )}
                            {data.referring_listing_agent_firm && data.referring_buyer_agent_firm && !externalBroker &&(
                                <React.Fragment>                                        
                                    <div className={`strive-content listing-both-referral ${
                                        referralListSideText.length >= maxLength ? "listing-both-referral-wrap-adjusted" : "" }`}>
                                        <div>{firstLineListSide}</div>
                                        <div>{secondLineListSide}</div>
                                    </div>
                                    <div className={`strive-content listing-commission-both-referral`}>
                                        {displayReferralListsideCommission()}
                                    </div>
                                    <div className={`strive-content buying-both-referral ${
                                        referralBuysideText.length >= maxLength ? "buying-both-referral-wrap-adjusted" : ""}`}>
                                        <div>{firstLineBuySide}</div>
                                        <div>{secondLineBuySide}</div>
                                    </div>                                   
                                    <div className={`strive-content buying-commission-both-referral`}>
                                        {displayReferralBuyerSideCommission()}
                                    </div>
                                    <div className={`strive-content both-listside-buyside-total-fee`}>
                                        {displayTotalCommission()}
                                    </div>
                                    <div className={`strive-content both-listside-buyside-comments`}>
                                        {data.name} - {data.city}, {data.state}
                                    </div>
                                </React.Fragment>
                            )}
                            {data.referring_listing_agent_firm && !data.referring_buyer_agent_firm && !externalBroker &&(
                                <React.Fragment>                                        
                                    <div className={`strive-content listing-referral ${
                                        referralListSideText.length >= maxLength ? "listing-referral-wrap-adjusted" : "" }`}>
                                        <div>{firstLineListSide}</div>
                                        <div>{secondLineListSide}</div>
                                    </div>
                                    <div className={`strive-content listing-commission-referral`}>
                                        {displayReferralListsideCommission()}
                                    </div>   
                                    

                                    <div className={`strive-content listside-buyside-total-fee`}>
                                        {displayTotalCommission()}
                                    </div>
                                    <div className={`strive-content listside-buyside-comments`}>
                                        {data.name} - {data.city}, {data.state}
                                    </div>                                 
                                </React.Fragment>
                            )}
                             {!data.referring_listing_agent_firm && data.referring_buyer_agent_firm && !externalBroker &&(
                                <React.Fragment>                                        
                                    
                                    <div className={`strive-content buying-referral ${
                                        referralBuysideText.length >= maxLength ? "buying-referral-wrap-adjusted" : ""}`}>
                                        <div>{firstLineBuySide}</div>
                                        <div>{secondLineBuySide}</div>
                                    </div>                                   
                                    <div className={`strive-content buying-commission-referral`}>
                                        {displayReferralBuyerSideCommission()}
                                    </div>
                                    <div className={`strive-content listside-buyside-total-fee`}>
                                        {displayTotalCommission()}
                                    </div>
                                    <div className={`strive-content listside-buyside-comments`}>
                                        {data.name} - {data.city}, {data.state}
                                    </div>
                                </React.Fragment>
                            )}
                            {data.referring_listing_agent_firm && !data.referring_buyer_agent_firm && externalBroker &&(
                                <React.Fragment>                                        
                                    <div className={`strive-content listing-referral-firm-with-outside-agent ${
                                        referralListSideText.length >= maxLength ? "listing-referral-firm-with-outside-agent-wrap-adjusted" : "" }`}>
                                        <div>{firstLineListSide}</div>
                                        <div>{secondLineListSide}</div>
                                    </div>
                                    <div className={`strive-content listing-commission-referral-with-outside-agent`}>
                                        {displayReferralListsideCommission()}
                                    </div>  
                                    <div className={`strive-content listing-referral-with-outside-agent ${
                                        outsideAgentText.length >= maxLength ? "listing-referral-with-outside-agent-wrap-adjusted" : "" }`}>
                                        <div>{firstLineOutSideAgent}</div>
                                        <div>{secondLineOutSideAgent}</div>
                                    </div>
                                    <div className={`strive-content commission-listing-referral-with-outside-agent`}>
                                        {displayBrokerFee()}
                                    </div> 
                                    <div className={`strive-content listside-with-outside-agent-total-fee`}>
                                        {displayTotalCommission()}
                                    </div>
                                    <div className={`strive-content listside-buyside-comments-with-outside-agent`}>
                                        {data.name} - {data.city}, {data.state}
                                    </div>                                 
                                </React.Fragment>
                            )}
                           {!data.referring_listing_agent_firm && data.referring_buyer_agent_firm && externalBroker &&(
                                <React.Fragment>                                        
                                    <div className={`strive-content buying-referral-with-outside-agent ${
                                        outsideAgentText.length >= maxLength ? "buying-referral-with-outside-agent-wrap-adjusted" : "" }`}>
                                        <div>{firstLineOutSideAgent}</div>
                                        <div>{secondLineOutSideAgent}</div>
                                    </div>
                                    <div className={`strive-content commission-buying-referral-with-outside-agent`}>
                                        {displayBrokerFee()}
                                    </div> 
                                    <div className={`strive-content buying-referral-firm-with-outside-agent ${
                                        referralBuysideText.length >= maxLength ? "buying-referral-firm-with-outside-agent-wrap-adjusted" : ""}`}>
                                        <div>{firstLineBuySide}</div>
                                        <div>{secondLineBuySide}</div>
                                    </div>                                   
                                    <div className={`strive-content buying-commission-referral-with-outside-agent`}>
                                        {displayReferralBuyerSideCommission()}
                                    </div>
                                    <div className={`strive-content buyside-referral-with-outside-agent-total-fee`}>
                                        {displayTotalCommission()}
                                    </div>
                                    <div className={`strive-content buyside-referral-with-outside-agent-comments`}>
                                        {data.name} - {data.city}, {data.state}
                                    </div>
                                </React.Fragment>
                            )}
                        </div> 
                </React.Fragment>
            )}
        <div className="Sale-information">
            <div className="Sale-information_column">                                
                <Input
                    className="Sale-information_column_item"
                    placeholder="MM/DD/YYYY HH:MM"
                    type="datetime-local"
                    valueType="datetime"
                    name="close_of_escrow"
                    label="Close Of Escrow"
                    value={data.close_of_escrow && viewMode ? formatToDateOnly(data.close_of_escrow) : data.close_of_escrow && !viewMode ? data.close_of_escrow : ""}
                    disabled={isAgent}
                    handleParentChange ={handleChangeInput}
                    handleParentBlur={isHsc ? handleInputBlur : null}
                    viewMode={viewMode}
                    deleted={deleted}
                    required={isSeniorAgent && data.source == 'External' && data.status =='Closed' ? true : null}
                />     
                {
                    isExtraPayment &&  <div>
                        <SelectTeam
                            className="Sale-information_column_item"
                            isFromProperty
                            value={data.listing_agent_1}
                            valueKey="listing_agent_1"
                            label="Agent"
                            data={data}
                            handleParentChange={handleChangeDropdown}
                            viewMode={viewMode}
                            deleted={deleted}
                        />                            
                        <Input
                            className="Sale-information_column_item"
                            type="text"
                            valueType="float"
                            name="referral_fee"
                            label="Fee Amount"
                            value={data.referral_fee}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                            decimals={2}
                            isDollar
                            disabled
                        />    
                       
                        <Input
                            className="Sale-information_column_item"
                            type="text"
                            valueType="float"
                            name="net_fee"
                            label="Net Amount" 
                            value={data.net_fee}                               
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                            decimals={2}
                            isDollar

                        />
                        <button type='button' className="button-new positive" onClick={calculateGrossAmount} viewMode={viewMode}>
                            Calculate Fee Amount
                        </button>
                        
                        
                    </div>
                }             
                {
                    (isReferral)?
                        <React.Fragment>
                             <SelectTeam
                                className="Sale-information_column_item"
                                isFromProperty
                                value={data.listing_agent_1}
                                valueKey="listing_agent_1"
                                percentKey="listing_agent_1_percent"
                                label="Referal Agent 1"
                                data={data}
                                hasAgentPercent={true}
                                handleParentChange={handleChangeDropdown}
                                handleInputParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                            />
                            <SelectTeam
                                className="Sale-information_column_item"
                                isFromProperty
                                value={data.listing_agent_2}
                                valueKey="listing_agent_2"
                                percentKey="listing_agent_2_percent"
                                label="Referal Agent 2"
                                data={data}
                                hasAgentPercent={true}
                                handleParentChange={handleChangeDropdown}
                                handleInputParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                            />
                            <Input
                                className="Sale-information_column_item"
                                type="text"
                                valueType="float"
                                name="referral_fee"
                                label="Fee Amount"
                                value={data.referral_fee}
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                decimals={2}
                                isDollar
                            />
                            <SelectFirm 
                                className="Sale-information_column_item"
                                value={data.referred_by_id}
                                valueKey='referred_by_id'
                                label='Referred By'
                                data={data}
                                handleParentChange={handleChangeDropdown}
                                viewMode={viewMode}
                                deleted={deleted}
                            />
                            <Dropdown
                                className="Sale-information_column_item"
                                data={data}
                                optionsType="referralType"
                                value={data.referral_type}
                                valueKey="referral_type"
                                label="Referral Type"
                                handleParentChange={handleChangeDropdown}
                                viewMode={viewMode}
                                deleted={deleted}
                            />
                        </React.Fragment>
                        
                        : !isExtraPayment && <div>
                        <React.Fragment>
                            <div className="estimated-price-container">
                                <Input             
                                className="Sale-information_column_item estimated-price"
                                type="text"
                                valueType="integer"
                                name="sold_price"
                                label="Price @ Close"
                                value={data.sold_price}
                                disabled={isAgent}
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                isDollar
                                />
                                <Dropdown
                                className="Sale-information_column_item estimated-price-type"
                                type="text"
                                valueType="text"
                                data={data}
                                optionsType="estimatedPrice"
                                value={data.estimated_price_type}
                                valueKey="estimated_price_type"
                                label="Type"
                                handleParentChange={handleChangeDropdown}
                                viewMode={viewMode}
                                deleted={deleted}
                                disabled={isAgent}
                                />
                            </div>
                            {data.SOURCE === "External" ? <Input
                                className="Sale-information_column_item"
                                type="text"
                                valueType="percent"
                                name="close_cap_rate"
                                label="Cap Rate @ Close - auto"
                                value={data.close_cap_rate}
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                disabled={isAgent} /> :
                                <Input
                                    className="Sale-information_column_item"
                                    type="text"
                                    valueType="percent"
                                    name="close_cap_rate"
                                    label="Cap Rate @ Close - auto"
                                    value={data.close_cap_rate}
                                    handleParentChange={handleChangeInput}
                                    viewMode={viewMode}
                                    deleted={deleted}
                                    disabled />
                            }
                            
                            <Input
                                className="Sale-information_column_item"
                                type="text"
                                valueType="integer"
                                name="close_noi"
                                label="NOI @ Close"
                                value={data.close_noi}
                                disabled={isAgent}
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                isDollar
                            />
                            <Input
                                className="Sale-information_column_item"
                                type="text"
                                valueType="float"
                                name="close_price_per_sqft"
                                label="PSF @ Close – auto"
                                value={data.close_price_per_sqft}
                                disabled
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                decimals={2}
                                isDollar
                            />
                            {
                                (isFinancing || isStriveFinancing) &&
                                <Input
                                    className="Sale-information_column_item"
                                    type="text"
                                    valueType="integer"
                                    name="down_payment"
                                    label="Down Payment"
                                    value={data.down_payment}
                                    disabled
                                    handleParentChange={handleChangeInput}
                                    viewMode={viewMode}
                                    deleted={deleted}
                                    isDollar
                                />
                            }
                            {
                                isFinancing &&
                                <Input
                                    className="Sale-information_column_item"
                                    type="text"
                                    valueType="integer"
                                    name="loan_amount"
                                    label="Loan Amount"
                                    value={data.loan_amount}
                                    disabled
                                    handleParentChange={handleChangeInput}
                                    viewMode={viewMode}
                                    deleted={deleted}
                                    isDollar
                                />
                            }
                        </React.Fragment></div>
                }
            </div>
            {
                !isReferral && !isFinancing && !isExtraPayment &&
                <div className="Sale-information_column">
                    <div className="Sale-information_column_closing_fee">
                        <div className="input-item">        
                            <Input            
                                type="text"
                                valueType="float"
                                name="TOTAL_CLOSING_FEE_AUTO"
                                label="Total Closing Fee - Auto"
                                value={totalClosingFeeAuto}
                                disabled
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                decimals={2}
                                isDollar
                            />
                        </div>
                        <div className="input-item">
                            <Input            
                                type="text"
                                valueType="percent"
                                label="Fee Percentage"
                                name="seller_fee_percentage"
                                value={data.seller_fee_percentage}
                                disabled
                                viewMode={viewMode}
                                deleted={deleted}
                            />
                        </div>
                    </div>
                    <Input
                        className="Sale-information_column_item"
                        type="text"
                        valueType="float"
                        name="list_fee"
                        label="List Fee - auto"
                        value={listFeeAuto}
                        disabled
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        decimals={2}
                        isDollar
                    />
                    <Input
                        className="Sale-information_column_item"
                        type="text"
                        valueType="float"
                        name="buyside_fee"
                        label="Buyside Fee - auto"
                        value={buySideFeeAuto}
                        disabled
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        decimals={2}
                        isDollar
                    />
                    <Input
                        className="Sale-information_column_item"
                        type="text"
                        valueType="float"
                        name="potential_fee"
                        label="STRIVE Fee - Auto"
                        value={data.potential_fee}
                        disabled
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        decimals={2}
                        isDollar
                    />
                    <UploadFiles 
                        classNames="Sale-information_column_item"
                        data={data}
                        viewMode={viewMode} 
                        deleted={deleted}
                        handleChangeFile={handleChangeFile}
                        initialFilesAmount={2}
                        maxFilesAmount={items.length}
                        items={items}
                        disabled={isAgent || isSeniorAgent}/>
                        <div>
                        {
                            isLoading &&<button className="button-new text" onClick={printHscInvoice} style={{ padding: "0", textAlign: "left" , color: '#90C54B'}}>Invoice & Wiring Instructions</button>
                        }
                        </div>
                </div>
            }
            
        </div>
        </React.Fragment>
    );
};

export default SaleInformation;
